import React from 'react';
import {Modal, ScrollView, Text, View} from 'react-native';

import {ModalTemplate} from '../../templates';
import {ModalCloseIcon} from '../../atoms';
import {styles} from './styles';
import translations from '../../../translations/ru.json';

const texts = translations.rules;

export const RulesModal = ({visible, onClose, isMobile}) => {
    return (
        <Modal
            animationType="fade"
            transparent={true}
            visible={visible}
            statusBarTranslucent
            onRequestClose={onClose}
        >
            <ModalTemplate>
                <View style={[styles.modalContainer, {/*{width: isMobile ? '100%' : '60%'}*/}]}>
                    <ModalCloseIcon onClose={onClose}/>
                    <ScrollView showsVerticalScrollIndicator={false} style={{flex: 1}}
                                contentContainerStyle={{padding: 10}}>
                        {/*<ModalTitle style={styles.title}>{texts.title}</ModalTitle>*/}
                        <Text style={styles.text}>{texts.texts}</Text>
                        <a href={'mailto:hi@dsml.ru'}>hi@dsml.ru</a>
                    </ScrollView>
                </View>
            </ModalTemplate>
        </Modal>
    );
};
